const axisStyleY = {
  axis: { stroke: '#dcdbdb', strokeWidth: 2 },
  ticks: { stroke: '#dcdbdb', strokeWidth: 2, size: 5, marginTop: 4 },
  tickLabels: {
    fontSize: '12px',
    fontWeight: 600,
    padding: 5,
    fontFamily: 'Roobert, sans-serif'
  }
}

const axisStyleX = {
  axis: { stroke: 'transparent' },
  ticks: { stroke: 'transparent' },
  tickLabels: {
    fontSize: '12px',
    fontWeight: 600,
    padding: 7,
    fontFamily: 'Roobert, sans-serif'
  },
  grid: { stroke: '#ececec', strokeWidth: 2 }
}

const toolTipStyle = {
  fontSize: '12px',
  fontFamily: 'Roobert, sans-serif',
  backgroundColor: '#fff'
}

export { axisStyleX, axisStyleY, toolTipStyle }
